import script from "./Years-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Years-popup.vue?vue&type=script&setup=true&lang=js"

import "./Years-popup.vue?vue&type=style&index=0&id=6f2d9d14&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2d9d14"]])

export default __exports__